import React from 'react';

interface HideOrShowProps {
  isHide: boolean;
  Component: React.ReactNode;
}

const HideOrShow = ({ isHide, Component }: HideOrShowProps) => {
  if (isHide) {
    return null;
  }

  return <>{Component}</>;
};

export default HideOrShow;
